import Vue from 'vue';
import {
    GET_ORDER_UNDONE_BY_CARNO_REQUEST,
    GET_ORDER_UNDONE_BY_CARNO_SUCCESS,
    GET_ORDER_UNDONE_BY_CARNO_FAILURE
} from '../mutationTypes';

const state = {
    loading: false,
    ordersUndone: [],
};
const mutations = {
    [GET_ORDER_UNDONE_BY_CARNO_REQUEST](state) {
        state.loading = true;
    },
    [GET_ORDER_UNDONE_BY_CARNO_SUCCESS](state, res) {
        state.loading = false;

        state.ordersUndone = res.orderList;
    },
    [GET_ORDER_UNDONE_BY_CARNO_FAILURE](state) {
        state.loading = false;
    },
};

export const actions = {
    async getRecentOrderUndone({ commit }, carNo) {
        commit(GET_ORDER_UNDONE_BY_CARNO_REQUEST);

        const res = await Vue.$ajax.get('hangoutOrder', {
            plateNum: carNo
        });

        if (!res.errorType) {
            commit(GET_ORDER_UNDONE_BY_CARNO_SUCCESS, res);
        } else {
            commit(GET_ORDER_UNDONE_BY_CARNO_FAILURE);
        }
    }
};

export default {
    state,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/open.js